import { defaultFormatChars } from "../constants.js";
const toMaskItems = (mask, currentFormatChars)=>{
    if ('string' != typeof mask) return mask.map((item)=>'string' == typeof item ? {
            editable: false,
            char: item
        } : {
            editable: true,
            rule: item
        });
    const items = [];
    let isEscaped = false;
    mask.split('').forEach((character)=>{
        if (!isEscaped && '\\' === character) {
            isEscaped = true;
            return;
        }
        const rule = isEscaped ? void 0 : currentFormatChars[character];
        items.push(rule ? {
            editable: true,
            rule
        } : {
            editable: false,
            char: character
        });
        isEscaped = false;
    });
    return items;
};
function parseMask({ mask, maskPlaceholder, formatChars }) {
    if (!mask) return null;
    const parsedMask = toMaskItems(mask, null != formatChars ? formatChars : defaultFormatChars);
    const literals = parsedMask.map((item)=>item.editable ? '' : item.char);
    let parsedMaskPlaceholder = maskPlaceholder || null;
    if (parsedMaskPlaceholder) if (1 === parsedMaskPlaceholder.length) {
        const placeholder = parsedMaskPlaceholder;
        parsedMaskPlaceholder = parsedMask.map((item, position)=>item.editable ? placeholder : literals[position]).join('');
    } else {
        const placeholderArray = parsedMaskPlaceholder.split('');
        parsedMask.forEach((item, position)=>{
            if (!item.editable) placeholderArray[position] = literals[position];
        });
        parsedMaskPlaceholder = placeholderArray.join('');
    }
    let prefix = '';
    let prefixPosition = 0;
    while(prefixPosition < parsedMask.length && !parsedMask[prefixPosition].editable){
        prefix += literals[prefixPosition];
        prefixPosition++;
    }
    let lastEditablePosition = parsedMask.length - 1;
    while(lastEditablePosition >= 0 && !parsedMask[lastEditablePosition].editable)lastEditablePosition--;
    return {
        maskPlaceholder: parsedMaskPlaceholder,
        prefix,
        mask: parsedMask,
        literals,
        lastEditablePosition
    };
}
export default parseMask;
